/*We log the error code from here so that irrespective of the user's current language the UI error info gets logged in English in Kusto*/

export enum  TranscriptionTelemetryErrorCodes {
   LoadTranscriptionStringsFailureMessage = "LoadTranscriptionStringsFailure",
   CookieSettingsFailureReason = "CookieSettingsFailure",
   InitHangFailureReason = "InitHangFailure",
   UnableToConnectToTranscriptionserviceFailureReason = "UnableToConnectToTranscriptionserviceFailure",
   UnableToAuthenticateNoBackupFailureReason = "UnableToAuthenticateNoBackupFailure",
   ConnectionIssueFailureReason = "ConnectionIssueFailure",
   UnknownInitFailureReason = "UnknownInitFailure",
   RecordingLostConnectionFailureReason = "RecordingLostConnectionFailure",
   RecordingLostConnectionNoBackupFailureReason = "RecordingLostConnectionNoBackupFailure",
   LostInternetConnectionReason = "LostInternetConnection",
   AuthenticationLoadingFailureReason = "AuthenticationLoadingFailure",
   UnsupportedUploadFileFormatFailureMessage = "UnsupportedUploadFileFormatFailure",
   InvalidOneDriveUploadFileNameFailureReason = "InvalidOneDriveUploadFileNameFailureReason",
   UploadTooLargeFailureReason = "UploadTooLargeFailure",
   RecoveryUploadTooLargeFailureReason = "RecoveryUploadTooLargeFailure",
   InvalidEmptyFileFailure = "InvalidEmptyFileFailure",
   OneDriveQuotaLimitReached = "OneDriveQuotaLimitReached",
   ForbiddenOneDriveAccess = "ForbiddenOneDriveAccess",
   UnknownLoadingFailureReason = "UnknownLoadingFailure",
   AuthRecoveringFailureReason = "AuthRecoveringFailure",
   UnknownRecordingFailureReason ="UnknownRecordingFailure",
   FileRecoveryFailedFailureReasonUnknown= "FileRecoveryFailedFailureReasonUnknown",
   FileDecodeFailureReason = "FileDecodeFailureReason",
   FileRecoveryFailedFailureReasonInvalidLicense = "FileRecoveryFailedFailureReasonInvalidLicense",
   FileRecoveryFailedFailureReasonQuotaLimitExceed = "FileRecoveryFailedFailureReasonQuotaLimitExceed",
   FileRecoveryFailedFailureReasonSessionExpired = "FileRecoveryFailedFailureReasonSessionExpired",
   FileRecoveryFailedFailureReasonResourceLocked = "FileRecoveryFailedFailureReasonResourceLocked",
   FileRecoveryFailedFailureReasonUnresolvableSystemErrors = "FileRecoveryFailedFailureReasonUnresolvableSystemErrors",
   FileRecoveryFailedFailureReasonFetchTokenFailed = "FileRecoveryFailedFailureReasonFetchTokenFailed",
   WriteContentToClientStorageFailedDuringMigration = "WriteContentToClientStorageFailedDuringMigration",
   PrivateBrowsingAuthFailure = "PrivateBrowsingAuthFailure"
};